class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
       setTimeout(updateCartDrawerTotal, 1500);  // 改成 1500ms
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
        	
      });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);


// 实时更新购物车结账金额
function updateCartDrawerTotal() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const formatted = '$' + (cart.total_price / 100).toFixed(2);
      document.querySelectorAll('.cart-drawer_total, [data-cart-subtotal]').forEach(el => {
        el.textContent = formatted;
      });
    });
}

// 拦截 fetch（加购用）
(function() {
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0]?.toString() || '';
    return originalFetch.apply(this, args).then(response => {
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        setTimeout(updateCartDrawerTotal, 800);
      }
      return response;
    });
  };
})();

// 拦截 XHR（加减/删除用）
(function() {
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    if (this._url && (this._url.includes('/cart/change') || this._url.includes('/cart/update'))) {
      this.addEventListener('load', function() {
        setTimeout(updateCartDrawerTotal, 800);
      });
    }
    return originalSend.apply(this, arguments);
  };
})();


// function updateCartDrawerTotal() {
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       const formatted = '$' + (cart.total_price / 100).toFixed(2);
//       document.querySelectorAll('.cart-drawer_total, [data-cart-subtotal]').forEach(el => {
//         el.textContent = formatted;
//       });
//     });
// }


// const originalFetch = window.fetch;
// window.fetch = function(...args) {
//   const url = args[0]?.toString() || '';
//   return originalFetch.apply(this, args).then(response => {
//     if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
//       setTimeout(updateCartDrawerTotal, 300);
//     }
//     return response;
//   });
// };


// 实时更新购物车结账按钮金额
// function updateCartDrawerTotal() {
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//     const totalEl = document.querySelector('.cart-drawer_total');
//       if (!totalEl) return;
//       const formatted = '$' + (cart.total_price / 100).toFixed(2);
//       totalEl.textContent = formatted;
//     });
// }
// function updateCartDrawerTotal() {
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       console.log('cart total_price:', cart.total_price);
//       const formatted = '$' + (cart.total_price / 100).toFixed(2);
      
//       // 更新所有金额显示元素
//       document.querySelectorAll('.cart-drawer_total, [data-cart-subtotal]').forEach(el => {
//         el.textContent = formatted;
//       });
//     });
// }

// // 统一监听所有购物车操作
// document.addEventListener('click', function(e) {
//   // 删除按钮
//   if (e.target.closest('.previewCartItem-remove')) {
//     setTimeout(updateCartDrawerTotal, 800);
//   }
//   // 加号按钮
//   if (e.target.closest('[data-plus-quantity-cart]')) {
//     setTimeout(updateCartDrawerTotal, 800);
//   }
//   // 减号按钮
//   if (e.target.closest('[data-minus-quantity-cart]')) {
//     setTimeout(updateCartDrawerTotal, 800);
//   }
// });

// // 监听数量输入框手动输入
// document.addEventListener('change', function(e) {
//   if (e.target.closest('.previewCartItem')) {
//     setTimeout(updateCartDrawerTotal, 800);
//   }
// });
